export enum UnitTypeEnum {
  Unit = 'unit',
  M2 = 'm2'
}